import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { Trash2 } from "lucide-react";
import PropTypes from "prop-types";
import React from "react";

const DeleteCaseModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <ConfirmDialog
      open={isOpen}
      onOpenChange={(next) => !next && onClose()}
      title="Delete Case"
      description="This permanently deletes the case and its documents. This action cannot be undone."
      confirmLabel="Delete case"
      cancelLabel="Keep case"
      onConfirm={onConfirm}
      variant="destructive"
      icon={Trash2}
    />
  );
};

DeleteCaseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteCaseModal;
